module.exports = __webpack_public_path__ + "img/group-49.5cddb049.svg";